import {
  COMPANY_STORAGE_LOCATION_LIST,
  COMPANY_STORAGE_LOCATION_LIST_SUCCESS,
  COMPANY_STORAGE_LOCATION_LIST_FAILURE,
  COMPANY_STORAGE_LOCATION_DATA,
  COMPANY_STORAGE_LOCATION_DATA_SUCCESS,
  COMPANY_STORAGE_LOCATION_DATA_FAILURE,
  COMPANY_STORAGE_LOCATION_CREATE,
  COMPANY_STORAGE_LOCATION_CREATE_SUCCESS,
  COMPANY_STORAGE_LOCATION_CREATE_FAILURE,
  COMPANY_STORAGE_LOCATION_UPDATE,
  COMPANY_STORAGE_LOCATION_UPDATE_SUCCESS,
  COMPANY_STORAGE_LOCATION_UPDATE_FAILURE,
  COMPANY_STORAGE_LOCATION_DELETE,
  COMPANY_STORAGE_LOCATION_DELETE_SUCCESS,
  COMPANY_STORAGE_LOCATION_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  companyStorageLocationList: [],
  companyStorageLocationListLoading: false,
  companyStorageLocationListError: null,

  companyStorageLocationData: [],
  companyStorageLocationDataLoading: false,
  companyStorageLocationDataError: null,

  companyStorageLocationCreate: [],
  companyStorageLocationCreateLoading: false,
  companyStorageLocationCreateError: null,

  companyStorageLocationUpdate: [],
  companyStorageLocationUpdateLoading: false,
  companyStorageLocationUpdateError: null,

  companyStorageLocationDelete: [],
  companyStorageLocationDeleteLoading: false,
  companyStorageLocationDeleteError: null,
};

const CompanyStorageLocation = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_STORAGE_LOCATION_LIST:
      return { ...state, companyStorageLocationListLoading: true, companyStorageLocationListError: null };
    case COMPANY_STORAGE_LOCATION_LIST_SUCCESS:
      return { ...state, companyStorageLocationList: action.payload, companyStorageLocationListLoading: false, companyStorageLocationListError: null };
    case COMPANY_STORAGE_LOCATION_LIST_FAILURE:
      return { ...state, companyStorageLocationList: [], companyStorageLocationListLoading: false, companyStorageLocationListError: action.payload };

    case COMPANY_STORAGE_LOCATION_DATA:
      return { ...state, companyStorageLocationDataLoading: true, companyStorageLocationDataError: null };
    case COMPANY_STORAGE_LOCATION_DATA_SUCCESS:
      return { ...state, companyStorageLocationData: action.payload, companyStorageLocationDataLoading: false, companyStorageLocationDataError: null };
    case COMPANY_STORAGE_LOCATION_DATA_FAILURE:
      return { ...state, companyStorageLocationData: [], companyStorageLocationDataLoading: false, companyStorageLocationDataError: action.payload };

    case COMPANY_STORAGE_LOCATION_CREATE:
      return { ...state, companyStorageLocationCreateLoading: true, companyStorageLocationCreateError: null };
    case COMPANY_STORAGE_LOCATION_CREATE_SUCCESS:
      return { ...state, companyStorageLocationCreate: action.payload, companyStorageLocationCreateLoading: false, companyStorageLocationCreateError: null };
    case COMPANY_STORAGE_LOCATION_CREATE_FAILURE:
      return { ...state, companyStorageLocationCreate: [], companyStorageLocationCreateLoading: false, companyStorageLocationCreateError: action.payload };

    case COMPANY_STORAGE_LOCATION_UPDATE:
      return { ...state, companyStorageLocationUpdateLoading: true, companyStorageLocationUpdateError: null };
    case COMPANY_STORAGE_LOCATION_UPDATE_SUCCESS:
      return { ...state, companyStorageLocationUpdate: action.payload, companyStorageLocationUpdateLoading: false, companyStorageLocationUpdateError: null };
    case COMPANY_STORAGE_LOCATION_UPDATE_FAILURE:
      return { ...state, companyStorageLocationUpdate: [], companyStorageLocationUpdateLoading: false, companyStorageLocationUpdateError: action.payload };

    case COMPANY_STORAGE_LOCATION_DELETE:
      return { ...state, companyStorageLocationDeleteLoading: true, companyStorageLocationDeleteError: null };
    case COMPANY_STORAGE_LOCATION_DELETE_SUCCESS:
      return { ...state, companyStorageLocationDelete: action.payload, companyStorageLocationDeleteLoading: false, companyStorageLocationDeleteError: null };
    case COMPANY_STORAGE_LOCATION_DELETE_FAILURE:
      return { ...state, companyStorageLocationDelete: [], companyStorageLocationDeleteLoading: false, companyStorageLocationDeleteError: action.payload };

    default:
      return state;
  }
};

export default CompanyStorageLocation;
